import { defineComponent as _defineComponent } from 'vue'
import BaseButton from "@/components/shared/button/base/BaseButton.vue";


const __default__ = {
  name: "FooterButton",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  title: {
    type: String,
    default: "",
  },
  disabled: {
    type: Boolean,
    default: false,
  },
},
  emits: ["onClickFooterButton"],
  setup(__props, { expose: __expose }) {
  __expose();





const __returned__ = { BaseButton }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})